module.exports = __webpack_public_path__ + "img/why-icon-2.029e9545.svg";